import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Item } from "./records";

const slice = createEntitySlice<Item>({ name: "roomItems" });

export const reducer = slice.reducer;
export const actions = slice.actions;
